import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    projects: [
        {
            id: "fancode-video",
            title: "FanCode Video System",
            description: "Architected scalable Video Infrastructure across Web & App",
            details: "Full details about scalable video infrastructure across web & app. More info here...",
            tag: "Tech",
        },
        {
            id: "ad-monetization",
            title: "Ad Monetization",
            description: "Integrated ad solutions to enhance revenue growth",
            details: "Full details about integrated ad solutions and revenue growth. More info here...",
            tag: "Tech",
        },
        {
            id: "flipkart-fashion",
            title: "Flipkart Fashion Revamp",
            description: "Revamped UI to boost user engagement by 23%",
            details: "Full details about UI revamp and user engagement boost. More info here...",
            tag: "Tech",
        },
        {
            id: "analytics-dashboard",
            title: "Live Analytics Dashboard",
            description: "Built real-time analytics dashboard for sports events",
            details: "Full details about real-time analytics dashboard for sports events. More info here...",
            tag: "Tech",
        },
        {
            id: "ad-insights",
            title: "Ad Insights Tool",
            description: "Developed ad insights and reporting tool for marketing teams",
            details: "Full details about ad insights and reporting tool for marketing teams. More info here...",
            tag: "Tech",
        },
    ],
    skills: [
        // Total: 8 years represents maximum skill level (100%)
        { name: "React", years: 7, total: 7 },
        { name: "React Native", years: 7, total: 7 },
        { name: "Redux", years: 7, total: 7 },
        { name: "Javascript", years: 7, total: 7 },
        { name: "TypeScript", years: 7, total: 7 },
        { name: "Leadership", years: 2, total: 7 },
    ],
    experiences: [
        {
            id: "senior-engineer-roku",
            title: "Senior Engineer, Roku",
            date: "Jul 2026 – Present",
            description: "Off-platform team building the Roku channel frontend across CTV devices and Web. Working on video playback, DRM-protected streaming, and ad integration for the Roku channel experience.",
            logo: "roku-logo.png",
            logoSize: { width: 48, height: 48 },
            isCurrent: true,
        },
        {
            id: "tech-lead-fleek",
            title: "Tech Lead, Fleek",
            date: "Jun 2025 – Jun 2026",
            description: "Led technical initiatives and architecture decisions for Fleek's platform.",
            logo: "fleek-yellow-logo.svg",
            logoSize: { width: 32, height: 32 },
        },
        {
            id: "sde3-fancode",
            title: "SDE 3, FanCode",
            date: "Jun 2022 – Jun 2025",
            description: "Led frontend architecture and UI for FanCode's core products.",
            logo: "fancode-icon.svg",
            logoSize: { width: 32, height: 32 },
        },
        {
            id: "sde2-fancode",
            title: "SDE 2, FanCode",
            date: "Nov 2020 – Jun2022",
            description: "Developed scalable features and improved performance for FanCode web and app.",
            logo: "fancode-icon.svg",
            logoSize: { width: 32, height: 32 },
        },
        {
            id: "ui-engineer-flipkart",
            title: "UI Engineer, Flipkart",
            date: "Jul 2018 – Nov 2020",
            description: "Revamped UI and enhanced user engagement for Flipkart Fashion.",
            logo: "flipkart-icon.svg",
            logoSize: { width: 24, height: 24 },
        },
        {
            id: "sde-intern-atkins",
            title: "SDE Intern, ATKINS",
            date: "May 2017 - Jul 2017",
            description: "Worked on Virtual Dimension Measuring App and Compared different 3d engines.",
            logo: "atkins-icon.svg",
            logoSize: { width: 50, height: 28 },
        },
    ],
    isLoading: false,
    currentProjectModal: null,
};
const portfolioSlice = createSlice({
    name: "portfolio",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        openProjectModal: (state, action) => {
            state.currentProjectModal = action.payload;
        },
        closeProjectModal: (state) => {
            state.currentProjectModal = null;
        },
        updateProjects: (state, action) => {
            state.projects = action.payload;
        },
        updateSkills: (state, action) => {
            state.skills = action.payload;
        },
        updateExperiences: (state, action) => {
            state.experiences = action.payload;
        },
    },
});
export const { setLoading, openProjectModal, closeProjectModal, updateProjects, updateSkills, updateExperiences, } = portfolioSlice.actions;
export default portfolioSlice.reducer;
